import React from "react";
import { useState, useEffect } from "react";
import logo from "../img/logo-02.png";
import { Link, useNavigate } from "react-router-dom";
import Loading from "./Loading";
import supabase from "../Supa";

/*
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import auth from "../firebase";*/

function Register({setToken}) {

  let navigate = useNavigate()
  const [userList, setUserList] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [er, setEr] = useState({status:false, massage:[]});
  const [success, setSucces] = useState(false);

  const [emailError, setEmailError] = useState(false);

  useEffect(() => {

    const session = sessionStorage.getItem('token')
    if(session){
      navigate('/home')
      }

    /*
    auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        window.location.href = "/dashboard";
      }
    });*/

  }, []);

  let signedUp = async (e) => {
    e.preventDefault();

      
 try {
  const { data, error } = await supabase.auth.signUp(
    {
      email: email,
      password: password
    }
  )
  if (error) throw error
    console.log(data)
    setToken(data)
  //navigate("/dashboard")
    setSucces(true)
    navigate("/profile")
    //  alert('Check your email for verification link')
 }catch(error){
  
  console.log(error)
        //alert(error)
        const ErrorMsg = JSON.stringify(error)
        const errorJsonString = ErrorMsg
        const parsedErrorObject = JSON.parse(errorJsonString);
        
        setEr({status:true, massage:parsedErrorObject.message})
 }

    /*
    await createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
       
        const user = userCredential.user;
        console.log(userCredential);
       
        await signInWithEmailAndPassword(auth, email, password).catch(
          (error) => {
            const errorCode = error.code;
            alert(errorCode);
          }
        );
      })
      .catch((error) => {
        const errorCode = error.code;
        alert(errorCode);
      });
    */ 


  };


  return (
    <>
      <div>
        <div className="Login-container">
          <div className="Login-left">
            <img
              src={logo}
              className="Login-animation a6"
              style={{ margin: "0 auto 10px", width: "150px" }}
              alt="Login"
            />
            {loading && <Loading />}
            <div className="Login-header">
              <h2 className="Login-animation a1">Join Us</h2>
              <p className="Login-animation a2">
                IG3N (Pty) Ltd is a manufacturing start-up that assembles
                LiFePO4 batteries and is currently the “Premier player”
                [assembler] in the Lithium Iron storage market in South Africa. {" "}
              </p>
            </div>
            <div className="Login-form">
              <input
                type="email"
                className="Login-form-field Login-animation a3"
                name=""
                placeholder="Email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <input
                type="password"
                className="Login-form-field Login-animation a4 "
                name=""
                placeholder="Password"
                style={{ marginTop: "10px" }}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />

                {success ? 
                <div class="alert alert-success" role="alert" style={{marginTop:"20px"}}>
                Check your email for verification link
                </div> : ""}

                {er.status ? 
                <div class="alert alert-danger" role="alert" style={{marginTop:"20px"}}>
                 {er.massage}
                </div> : ""}

              <div className="Login-animation a5" style={{ margin: "20px" }}>
                <span style={{ fontSize: "12px" }}>

                  {/* 
                  <input
                    type="checkbox"
                    id="check"
                    className="Login-animation a5"
                    name=""
                  />
                  <label
                    for="check"
                    style={{ paddingLeft: "10px", color: "#afafaf" }}
                  >
                    Remember my password
                  </label>{" "}
                  |*/}
                  
                  {" "}
                  <Link to="/" className="">
                    Login{" "}
                  </Link>{" "}
                </span>
              </div>
              <div style={{ textAlign: "end" }}>
                <button className="btn1 btn-default" onClick={signedUp}>
                  Register
                </button>
              </div>
            </div>
          </div>
          <div id="Loing-right"></div>
        </div>
      </div>

      {/*Register intergration 
        <div>
            <input type="text" placeholder='Email' onChange={(event) => {setEmail(event.target.value)}} />
            <input type="text" placeholder='Password' onChange={(event) => {setPassword(event.target.value)}} />
            <button onClick={createUser}>Create User</button>
        </div>

        <div>{userList.map((user) =>{
        return(
          <> 
          <hr />
            <p>Email: {user.email}</p>
            <p>Password: {user.password}</p>
          </>
        )
      })}</div>*/}
    </>
  );
}

export default Register;
